// extracted by mini-css-extract-plugin
module.exports = {"bannerLayout":"cKdvR","changeBanner":"_11G1J","banner":"_2UCj7","title":"_3AK0P","title2":"_3PmYt"};